import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useAppApi } from "@/App";
import { RenderForm } from "@components/Forms/Render";
import { Awesome } from "@components/Helpers";
import { ListingCard } from "@components/Pages";
import { NothingFilteredAlert } from "@components/Statistics";
import { money_fmt, url_reverse } from "@components/Utils";

export default function StatisticsRefunds({ gameId, header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:game:statistics:refunds", { game_id: gameId }));

    if (!apiData) return;

    return (
        <ListingCard header={header} filterComponent={false}>
            <RenderForm prefix="filter" submitButtonText={t("Построить")} submitMethod="get" />

            {apiData.stats_summary?.length > 0 && (
                <div className="jumbotron p-3 mb-0 mt-3">
                    <h4>{t("Итого за период")}:</h4>
                    <div>
                        {apiData.stats_summary.map((s, ind) => (
                            <div key={`stats_summary_${ind}`}>
                                <strong>{s.original_transaction__currency}:</strong> {money_fmt(s.amount)} ({s.count})
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <NothingFilteredAlert />

            {apiData.object_list?.length > 0 && (
                <Table hover responsive className="dmg-table mt-4">
                    <thead>
                        <tr>
                            <th>{t("Дата/время")}</th>
                            <th>{t("Сумма")}</th>
                            <th>{t("Валюта")}</th>
                            <th>User ID</th>
                            <th>{t("ID транзакции")}</th>
                            <th>{t("ID Транзакции возврата")}</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {apiData.object_list?.map((obj) => {
                            return (
                                <tr key={obj.id}>
                                    <td>{obj.date}</td>
                                    <td>{obj.original_transaction.payment_sum}</td>
                                    <td>{obj.original_transaction.currency}</td>
                                    <td>{obj.original_transaction.pers_id}</td>
                                    <td>{obj.original_transaction.transaction_id}</td>
                                    <td>{obj.refund_transaction_id}</td>
                                    <td>
                                        <Awesome
                                            type="info-circle"
                                            tooltip={t(
                                                'Возврат денег осуществляется в течении 3х рабочих дней после перехода транзакции в статус "Успешно"'
                                            )}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            )}
        </ListingCard>
    );
}
